import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

class FeatureWizardSteps extends Component {

  static propTypes = {
    availableSteps: PropTypes.array,
    featureWizardStep: PropTypes.number,
    setFeatureWizardStep: PropTypes.func,
    exitFeatureWizard: PropTypes.func,
    getFilterDisplayName: PropTypes.func.isRequired,
    toggleWizardFilterSelection: PropTypes.func,
    allProducts: PropTypes.bool,
    allStepsCompleted: PropTypes.bool,
    finishClicked: PropTypes.bool,
    showFeatureWizard: PropTypes.bool,
  };

  setFeatureWizardStep = (nextStep, disabled) => {

    if (disabled) {
      return false;
    }

    switch (nextStep) {
      case "back":
        nextStep = this.props.featureWizardStep === 0 ? 0 : this.props.featureWizardStep - 1;
        break;
      case "next":
        if (this.props.featureWizardStep === (this.props.availableSteps.length - 1)) {
          this.props.exitFeatureWizard(this.props.availableSteps);
          return;
        } else {
          nextStep = this.props.featureWizardStep + 1;
        }
        break;
      default:
        break;
    }
    const currentStep = this.props.availableSteps[nextStep - 1];
    const fabricatorSettings = this.props.fabricatorSettings;
    if ((nextStep > this.props.featureWizardStep) && currentStep && !this.props.allStepsCompleted
      && (!currentStep.selectedValueId || (fabricatorSettings.leadCapture && currentStep.selectedItemIsLocked && !this.props.isPhoneNumberValidated))) {
      return
    }
    if (this.props.showFeatureWizard) {
      this.props.setFeatureWizardStep(nextStep);
      if (nextStep === 0) {
        this.props.toggleWizardFilterSelection(false);
      }
    } else {
      this.props.enableFeatureWizard(nextStep);
    }
  };

  render() {
    // console.log('features top', this.props.features);
    const currentStep = this.props.availableSteps[this.props.featureWizardStep];
    // const nextStep = this.props.availableSteps[this.props.featureWizardStep + 1];
    const isLastStep = this.props.featureWizardStep === this.props.availableSteps.length - 1;

    const fabricatorSettings = this.props.fabricatorSettings;
    const nextStepIsLocked = currentStep && !this.props.allStepsCompleted && fabricatorSettings.leadCapture && currentStep.selectedItemIsLocked && !this.props.isPhoneNumberValidated;

    const lastStepIsDisabled = currentStep && (!currentStep.selectedValueId || nextStepIsLocked);

    return (
      <div className={"wiz" + (this.props.isMobile ? "" : " wiz--desktop")}>
        {this.props.showFeatureWizard && (this.props.allProducts || !this.props.allStepsCompleted || (this.props.allStepsCompleted && !this.props.finishClicked)) ? (
          <div className={"wiz__arrow wiz__arrow--left"
          + (!this.props.featureWizardStep ? " wiz__arrow--disabled" : "")} onClick={() => this.setFeatureWizardStep("back")}>
            <span><FormattedMessage id="filterSelection.wizard.back"/></span>
          </div>
        ) : null}
        <ul className={"wiz__button-list"
        + (this.props.isMobile ? " wiz__button-list--"+this.props.featureWizardStep : " wiz__button-list--0")
        + (this.props.isMobile ? " wiz__button-list--total-items-"+this.props.availableSteps.length : "")
        + (this.props.allProducts  || this.props.finishClicked ? " wiz__button-list--completed" : "")}>
          {this.props.allProducts || (this.props.showFeatureWizard && this.props.finishClicked) ? (
            <li className={"wiz__button wiz__button--all"
          + (!this.props.showFeatureWizard ? " wiz__button--active" : "")}
                onClick={() => this.props.exitFeatureWizard(this.props.availableSteps)}>
              <span><FormattedMessage id="filterSelection.allItems"/></span>
            </li>
          ) : null}
          {this.props.availableSteps.map((wizardButton, index) => {
            const prevStep = this.props.availableSteps[index - 1];
            const disabled = index && (!prevStep.selectedValueId
              || (fabricatorSettings.leadCapture && prevStep.selectedItemIsLocked && !this.props.isPhoneNumberValidated));
            const buttonName = this.props.getFilterDisplayName(wizardButton.filterName);
            const displayName = this.props.getFilterDisplayName(wizardButton.filterName, this.props.intl);
            return (
              <li className={"wiz__button wiz__button--" + buttonName.replace(/ /g,"").toLowerCase()
              + (index === this.props.featureWizardStep && !this.props.allProducts ? " wiz__button--active" : "")
              + (disabled ? " wiz__button--disabled" : "")}
                  key={"wizardButton"+index} onClick={() => this.setFeatureWizardStep(index, disabled)}>
                <span>{displayName}</span>
                {this.props.availableSteps[index].selectedValueId && index !== this.props.featureWizardStep
                  ? <span className="ui-checkark wiz__button-checkmark"/>
                  : null
                }
              </li>
            )
          })}
        </ul>
        {this.props.showFeatureWizard && (this.props.allProducts || !this.props.allStepsCompleted || (this.props.allStepsCompleted && !this.props.finishClicked)) ? (
          <div className={"wiz__arrow wiz__arrow--right"
          + (lastStepIsDisabled ? " wiz__arrow--disabled" : "")
          + (currentStep && currentStep.selectedValueId ? " wiz__arrow--blinking" : "")}
               onClick={() => this.setFeatureWizardStep("next", lastStepIsDisabled)}>
            <span>
              <FormattedMessage id={isLastStep ? "filterSelection.wizard.finish" : "filterSelection.wizard.next"}/>
            </span>
          </div>
        ) : null}
      </div>
    )
  }
}


const mapStateToProps = (store) => ({
  fabricatorSettings: store.fabricatorState.settings,
});

const mapDispatchToProps = () => ({});

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeatureWizardSteps)
);
